import { render, staticRenderFns } from "./IndexCollateral.vue?vue&type=template&id=583604ec&"
import script from "./IndexCollateral.vue?vue&type=script&lang=js&"
export * from "./IndexCollateral.vue?vue&type=script&lang=js&"
import style0 from "./IndexCollateral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports